import { render } from "./ComponentGallery.vue?vue&type=template&id=d567d468"
import script from "./ComponentGallery.vue?vue&type=script&lang=js"
export * from "./ComponentGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__